<template>
  <button
    v-if="showStar"
    v-on:click="toggleFavourite"
    v-bind:class="'add-to-favorites btn btn-link ' + button_class"
    :title="titleText"
    :aria-label="titleText"
    :data-bs-original-title="titleText"
    data-bs-toggle="tooltip"
    data-bs-placement="bottom"
  >
    <i v-if="!itemInFavourites" class="fa-light fa-star text-muted fs-4"></i>
    <i v-if="itemInFavourites" class="fa-solid fa-star text-yellow fs-4"></i>
  </button>
  <a
    v-if="showLink"
    class="dropdown-item d-flex align-items-start justify-content-between small"
    href="#"
    v-on:click="toggleFavourite"
  >
    <span v-if="!itemInFavourites">{{ addText }}</span>
    <span v-else>{{ removeText }}</span>
  </a>
</template>

<script>
const fallbackTranslations = {
  add: 'Add to favourites',
  remove: 'Remove from favourites',
};

export default {
  data () {
      return {
        itemInFavourites: false,
        showStar: true,
        showLink: false
      };
  },

  computed:{
    titleText(){
      return this.itemInFavourites ? this.removeText : this.addText;
    },
    addText() {
      return this.t('add');
    },
    removeText() {
      return this.t('remove');
    },
  },

  methods: {
    t(key) {
      if (this.translations && Object.prototype.hasOwnProperty.call(this.translations, key)) {
        return this.translations[key];
      }

      return fallbackTranslations[key] || key;
    },
    toggleFavourite: function() {
      $('[data-bs-toggle="tooltip"]').tooltip('hide');
      axios.post("/toggle_favourite", {
        id: this.id,
        model: this.model
      })
      .then((response) => {
        const data = response.data;

        if (data == 'added_to_favourites') {
          this.itemInFavourites = true;
        } else {
          this.itemInFavourites = false;
        }
      });
    }
  },

  props: {
      button_class: {
        type: String,
        default: 'pe-0',
      },
      id: {
        type: [String, Number],
        required: true,
      },
      in_fav: {
        type: [String, Number, Boolean],
        default: 0,
      },
      model: {
        type: String,
        default: '',
      },
      show_link: {
        type: [Boolean, String],
        default: false,
      },
      show_star: {
        type: [Boolean, String],
        default: true,
      },
      translations: {
        type: Object,
        default: () => ({}),
      },
  },

  created() {
    this.itemInFavourites = this.in_fav === true || this.in_fav === 1 || this.in_fav === '1';
    this.showStar = this.show_star === true || this.show_star === 'true' || this.show_star === 1 || this.show_star === '1';
    this.showLink = this.show_link === true || this.show_link === 'true' || this.show_link === 1 || this.show_link === '1';
  }
}
</script>
